import React from "react";
import { Link } from "react-router";
import "./offers.scss";
import {
  ArrowRight,
  Ceiling,
  Home,
  Panels,
  Plasterboard,
  Spackling,
} from "../../../icons";

const Offers: React.FC = () => {
  return (
    <section className="offers">
      <div className="offers__header">
        <span className="offers__header-line"></span>
        <h2 className="offers__title">Nasza oferta</h2>
        <span className="offers__header-line"></span>
      </div>

      <div className="offers__grid">
        <div className="offers__card">
          <div className="offers__icon">
            <Plasterboard />
          </div>
          <h3 className="offers__card-title">PŁYTY GK</h3>
          <p className="offers__card-subtitle">
            ściany działowe <br /> zabudowy
          </p>
        </div>

        <div className="offers__card">
          <div className="offers__icon">
            <Ceiling />
          </div>
          <h3 className="offers__card-title">SUFITY</h3>
          <p className="offers__card-subtitle">podwieszane</p>
        </div>

        <div className="offers__card">
          <div className="offers__icon">
            <Panels />
          </div>
          <h3 className="offers__card-title">PANELE</h3>
          <p className="offers__card-subtitle">/ parkiet</p>
        </div>

        <div className="offers__card">
          <div className="offers__icon">
            <Spackling />
          </div>
          <h3 className="offers__card-title">SZPACHLOWANIE</h3>
          <p className="offers__card-subtitle">/ malowanie</p>
        </div>

        <div className="offers__card">
          <div className="offers__icon">
            <Home />
          </div>
          <h3 className="offers__card-title">KOMPLEKSOWE</h3>
          <p className="offers__card-subtitle">wykończenia wnętrz</p>
        </div>
      </div>

      <div className="offers__action">
        <Link to="/oferta" className="offers__button">
          <span>ZOBACZ CAŁĄ OFERTĘ</span>
          <ArrowRight />
        </Link>
      </div>
    </section>
  );
};

export default Offers;
